export default { sha: '7688a808cbcba48962337fc388115de96ce0c8b1', buildNumber: 'undefined' }
